<template>
  <div>
    <vuetify-google-autocomplete
      id="searchLocation"
      v-model="location"
      append-icon="place"
      :label="adminText(&quot;shellAll.enter_a_location&quot;, &quot;Enter a location&quot;)"
      clearable
      types=""
      box
      style="margin-bottom: 12px"
      :error-messages="getErrors(validator)"
      @input="onInputChange($event)"
      @blur="validator && validator.$touch()"
      @placechanged="setPlace"
    />
    <div v-if="form && form.latitude && form.longitude">
      <gmap-map
        :zoom="13"
        :center="{
          lat: form.latitude,
          lng: form.longitude,
        }"
        :options="{
          disableDefaultUI: true,
          fullscreenControl: true,
        }"
        class="map"
      >
        <gmap-marker
          :position="{
            lat: form.latitude,
            lng: form.longitude,
          }"
          label="■"
        />
      </gmap-map>
    </div>
    <text-field v-model.trim="form.venue" :label="adminText(&quot;shellAll.venue_name&quot;, &quot;Venue name*&quot;)" :validator="validator.venue" />
    <text-field v-model.trim="form.address1" :label="adminText(&quot;shellAll.address&quot;, &quot;Address*&quot;)" :validator="validator.address1" />
    <v-layout row>
      <v-flex xs12 md6 class="pr-30">
        <text-field v-model.trim="form.city" :label="adminText(&quot;shellAll.city&quot;, &quot;City&quot;)" />
        <text-field v-model.trim="form.state" :label="adminText(&quot;shellAll.state&quot;, &quot;State&quot;)" />
      </v-flex>
      <v-flex xs12 md6>
        <!--        <text-field v-model.trim="form.address2" label="Address 2" />-->
        <text-field v-model.trim="form.postalCode" :label="adminText(&quot;shellAll.postal_code&quot;, &quot;Postal code&quot;)" />
        <text-field v-model.trim="form.country" :label="adminText(&quot;shellAll.country&quot;, &quot;Country&quot;)" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  mixins: [AdminContext],
  name: 'location',
  props: {
    value: {
      type: Object,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        ...this.value,
        latitude: this.value && this.value.latitude ? this.value.latitude : 45.8087407,
        longitude: this.value && this.value.longitude ? this.value.longitude : 15.9740865,
      },
      location: this.value.address1,
    }
  },
  watch: {
    form: {
      handler(data) {
        this.$emit('input', data)
      },
      deep: true,
    },
  },
  methods: {
    onInputChange(val) {
      if (!val) {
        this.location = null
        this.form = { latitude: 45.8087407, longitude: 15.9740865 }
      }
      this.validator && this.validator.$touch()
    },
    getErrors: function (field) {
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
    getAddress(location) {
      return `${location.route ? location.route : ''} ${
        location.street_number ? location.street_number : ''
      }`
    },
    setPlace(location, place) {
      if (location) {
        this.location = place.vicinity || ''
        this.form = {
          ...this.form,
          address1: this.getAddress(location),
          city: location.locality,
          postalCode: location.postal_code,
          state: location.administrative_area_level_1,
          country: location.country,
          latitude: location.latitude,
          longitude: location.longitude,
          venue: '',
        }
      }
    },
  },
}
</script>

<style>
.map {
  width: 100%;
  height: 10rem;
  margin-bottom: 1.25rem;
}

.pr-30 {
  margin-right: 1.875rem;
}
</style>
